import React from 'react'
import { Link } from 'react-router-dom'

export default props => (
    <li className="nav-item perfil-acesso" onClick={props.onClick}>
        <Link to={props.path} className={`nav-link ${props.active ? 'active' : ''}`} 
            style={{
                display: 'flex',
                alignItems: 'center',
                gap: 8,
                paddingLeft: props.submenu ? 15 : null,
                backgroundColor: props.submenu && !props.active ? '#f5f2f2' : null,
                borderRadius: props.active ? 8 : null,
                transition: 'all 0.2s ease',
                height: 42,
            }}>
            <i className={`nav-icon ${props.icon}`} 
                style={{
                    fontSize: props.submenu ? 14 : 16,
                    width: 20,
                    textAlign: 'center',
                    minWidth: 20
                }}
                title={props.title}></i>
			<p style={{
                fontSize: props.submenu ? 14 : 15, 
                margin: 0,
                display: 'flex', 
                alignItems: 'center',
                flex: 1
            }}>
				{props.label}
				<span class={`badge badge-${props.spanType} right`}>{props.span}</span>
			</p>
        </Link>
    </li>
)
